
import { formatClock, formatClockRange, toInstant, type Instant } from '@shared/tz';

export function formatListingTime(instant: Instant, zone: string | null | undefined): string {
  return formatClock(instant, zone);
}

export function formatListingClock(instant: Instant, zone: string | null | undefined): string {
  return formatClock(instant, zone);
}

export function formatListingRange(
  start: Instant,
  end: Instant,
  zone: string | null | undefined,
): string {
  return formatClockRange(start, end, zone);
}

export function listingZoneLabel(zone: string | null | undefined, instant: Instant = new Date()): string {
  const z = zone && zone.trim() !== '' ? zone : 'America/Los_Angeles';
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZoneName: 'short',
      timeZone: z,
    }).formatToParts(toInstant(instant));
    return parts.find((p) => p.type === 'timeZoneName')?.value ?? '';
  } catch {
    return '';
  }
}
